export enum METHOD_API {
    GET_SHOPIFY_ORDERS = 'dlad_shopify_connector.api.exec_query',
    SYNC_SHOPIFY_ORDERS = 'dlad_shopify_connector.sync_to_sap.enqueue',
}